module.exports = __webpack_public_path__ + "static/img/liyanguoji.e70f663.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/liyanguoji.png
// module id = xWC6
// module chunks = 1